"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoupleLeftImageProperty = exports.coupleLeftImagePropertyDefinition = void 0;
exports.coupleLeftImagePropertyDefinition = {
    view: {
        label: 'Couple left image',
        style: 'media-preview',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'couple-left-image',
};
const isCoupleLeftImageProperty = (prop) => {
    return prop.name === exports.coupleLeftImagePropertyDefinition.name;
};
exports.isCoupleLeftImageProperty = isCoupleLeftImageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291cGxlLWxlZnQtaW1hZ2UucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jb3VwbGUtbGVmdC1pbWFnZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxtQkFBbUI7UUFDMUIsS0FBSyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQztTQUNwQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxtQkFBbUI7Q0FDTSxDQUFBO0FBSTFCLE1BQU0seUJBQXlCLEdBQUcsQ0FBQyxJQUFrQixFQUFtQyxFQUFFO0lBQy9GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx5Q0FBaUMsQ0FBQyxJQUFJLENBQUE7QUFDN0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx5QkFBeUIsNkJBRXJDIn0=